export default {
    round(number, digits) {
        const multiple = Math.pow(10, digits);

        return (Math.round(number * multiple) / multiple).toFixed(digits);
    }
};
